import { lazy } from "react";

export { SHIFT_LIST_PAGE_PATH } from "./path";
export const ShiftListPage = lazy(() => import("./page"));
